<template>
  <div ref="sdh" class="segment-expansion-holder">
    <div v-if="type === 'slope' && num === 0" class="slope-options">
      <div class="slope-option" :class="selectedOption('start')" @click="setOption('start')">start</div>
      <div class="slope-option" :class="selectedOption('slope')" @click="setOption('slope')">slope</div>
    </div>
    <NumericField
      v-show="option === 'start'"
      v-if="type === 'slope' && num === 0"
      :segment="getSegment"
      type="start-gradient"
      layout="row"
      :no-label="type === 'slope' && num === 0"
    />
    <NumericField
      v-show="option === 'slope'"
      v-if="type === 'slope'"
      :segment="getSegment"
      type="gradient"
      layout="row"
      :no-label="type === 'slope' && num === 0"
    />
    <OptionDropDown v-if="type === 'pipe'" :segment="getSegment" @overflow="handleOverflow" />
  </div>
</template>

<script>
import { usePipeStore } from '@/store/PipeStore';
import NumericField from '@/components/nelson/NumericField';
import OptionDropDown from '@/components/nelson/OptionDropDown';
import { useModalStore } from '@/store/ModalStore';
import { gsap } from 'gsap';
import { usePrintStore } from '../../store/PrintStore';

export default {
  name: 'SegmentDropdown',
  components: {
    NumericField,
    OptionDropDown
  },
  data () {
    return {
      expanded: true,
      option: 'slope'
    };
  },
  emits: [
    'expanded'
  ],
  props: [
    'type',
    'segment',
    'num'
  ],
  computed: {
    getSegment () {
      return this.$props.segment;
    },
    getIsPrint () {
      return !usePrintStore().getPrintIsOpen;
    },
  },
  methods: {
    selectedOption (option) {
      if (this.option === option) {
        return 'option-selected';
      }
    },
    setOption (option) {
      this.option = option;
    },
    toggle () {
      gsap.to(this.$refs.sdm, {
        width: (!this.expanded) ? 'auto' : 0,
        duration: .1
      });
      this.expanded = !this.expanded;
      this.$emit('expanded', this.expanded);
    },
    expand () {
      gsap.to(this.$refs.sdm, {
        width: 'auto',
        duration: .1
      });
      this.expanded = true;
      this.$emit('expanded', this.expanded);
    },
    close () {
      gsap.to(this.$refs.sdm, {
        width: 0,
        duration: .1
      });
      this.expanded = false;
      this.$emit('expanded', this.expanded);
    },
    handleOverflow (bool) {
      if (bool) {
        this.$refs.sdm.classList.add('segment-overflow');
      } else {
        this.$refs.sdm.classList.remove('segment-overflow');
      }
    },
    handleEditPipe () {
      const pipeStore = usePipeStore();
      let pipe = pipeStore.getPipeById(this.getSegment.id);
      pipeStore.getPipes.forEach((element) => {
        element.isHover = false;
      });
      pipeStore.setPipeModalVisible(true);
      pipeStore.setEditedPipe(pipe);
      useModalStore().showModal('pipe');
    }
  }
};
</script>

<style scoped>
.segment-expansion-mask {
  overflow: hidden;
  transition: .3s width;
}
.segment-expansion-holder {
  background-color: lightgrey;
  transition: .3s transform;
  display: flex;
  padding-top: 3px;
  padding-bottom: 3px;
}
.segment-expand {
  width: inherit;
}
.segment-overflow {
  overflow: visible;
}
.edit-btn {
  width: 18px;
  height: 18px;
  background-color: gray;
  border-radius: 15px;
  margin-left:10px;
  margin-right:10px;
  margin-top:5px;
  cursor:pointer;
}
.slope-options {
  margin-left: 4px;
  display: flex;
}
.slope-option {
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 6px;
  padding-right: 6px;
  cursor: pointer;
  border-radius: 6px;
}
.option-selected {
  background-color: #a8a8a8;
  font-weight: bold;
}
</style>